import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostSignup } from "hooks/api";
import { usePostLogin } from "hooks/api";
import { IkakaoLogin  } from 'common/interface/login';
import { authMakeCookieData } from 'hooks/util/makeCookie';
import BigText from "components/ui/BigText";
import SmallText from "components/ui/SmallText";
import { Button } from "components/ui";
import ReactGA from "react-ga4";
import LoadingOverlay from 'components/ui/login/LoadingOverlay';
import RandomString from 'hooks/util/randomString';


const Elem:React.FC<any> = ({ children }) => {
  const { mutateAsync: postSignUp }    = usePostSignup();
  const { mutateAsync: postLogin }     = usePostLogin();
  const [ accessToken, setaccessToken ] = useState("");
  const [ loading, setLoading ] = useState(true);
  const location = useLocation();

  // const medium = localStorage.getItem('medium');
  const REST_API_KEY = process.env.REACT_APP_KAKAO_REST_API_KEY || "";
  const REDIRECT_URI = process.env.REACT_APP_KAKAO_REDIRECT_URI || ""; 

  const handleKakaoLoginCallback = async () => {
    setLoading(true);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const code = urlSearchParams.get('code') as any;

    const response = await fetch(`https://kauth.kakao.com/oauth/token`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
      body: new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: REST_API_KEY,
        redirect_uri: REDIRECT_URI,
        code
      }),
    });
    
    const data = await response.json();
    const kakaoAccessToken = data.access_token;
    setaccessToken(kakaoAccessToken)

    await getUserInfoInKakao(kakaoAccessToken);
  };

  const getUserInfoInKakao = async (kakaoAccessToken:string) =>{
    const response = await fetch(`https://kapi.kakao.com/v2/user/me` , {
      method: 'POST',
      headers: {
        "Authorization" : `Bearer ${kakaoAccessToken}`,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  
    const data = await response.json();
    const snsId = data.id;
    
    const result = await login({
      snsId:snsId
    });

    // await handleAccessServiceTerm(kakaoAccessToken, snsId);
    let newAccessToken:string;
    let refreshToken:string;
    if (result.status === 200) {
      newAccessToken = await result.data.accessToken.token;
      refreshToken = await result.data.newRefreshToken.token;
      await authMakeCookieData(newAccessToken);
      localStorage.setItem("token", refreshToken);
      console.log(result.data.tempUserData.id)
      localStorage.setItem('name', result?.data.tempUserData.id)
      setLoading(false)
      window.location.href="/home"
    } else {
      const { name, phone_number } = data?.kakao_account;
      // const randomCode = await RandomString();
      const signUpResult = await signUp({
        snsId,
        kakaoAccessToken,
        social: "kakao",
        name : name || "",
        mobile:phone_number || ""
        // medium,
      });

      newAccessToken = signUpResult.accessToken.token;
      refreshToken = signUpResult.refreshToken.token;
      await authMakeCookieData(newAccessToken);
      localStorage.setItem("token", refreshToken)
      localStorage.setItem('name', signUpResult.userId);

      if (signUpResult?.isGiftNumber === 1) {
        setLoading(false)
        window.location.href="/onboarding/1/freekit"  
      } else if (signUpResult?.isGiftNumber === 2) {
        setLoading(false)
        window.location.href="/onboarding/1/freekit"  
      } else if (signUpResult?.isGiftNumber === 3) {
        setLoading(false)
        window.location.href="/onboarding/2/detail"
      }
    }
  }

  const login = async ({snsId}:{ snsId:string }) => {
    const result = await postLogin({
      snsId
    })

    return result;
  }

  const signUp = async ({snsId, kakaoAccessToken, name, mobile }:IkakaoLogin) => {
    const result = await postSignUp({
      snsId : snsId,
      kakaoAccessToken,
      social : "kakao",
      name: name || "",
      mobile: mobile || ""
    });

    return result
  }
  
  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
  

  useEffect (() => {
    if (gaId) {
      ReactGA.send({ hitType: "pageview", page:"kakaoLogin", title: "Kakao Login" })
    }
  },[])

  useEffect(() => {
    if (!location.search) return;
    //@ts-ignore
      handleKakaoLoginCallback();
  }, [location.search, REST_API_KEY, REDIRECT_URI]);

  return (
      <>
        <Container>
        <HeaderContainer>
          <ImgContainer>
            <LogoImg src='/images/logoImg2.png'/>
          </ImgContainer>
          </HeaderContainer>
          <TextContainer>
            포티페타 가입중입니다. 잠시만 기다려 주세요 ..!!
          </TextContainer>
          < LoadingOverlay loading={loading}/>
        </Container>
      </>
  )
}

export default Elem;


const Container = styled.div`
  width: 100%;
  /* height: 100%; */
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const HeaderContainer = styled.div`
  width: 100%;
  height: 69px;
  
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const ImgContainer = styled.div`
  width: 118px;
  height: 25.62px;
  margin-left: 17px;
`
const LogoImg = styled.img`
  width: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 250px auto;
`


const LogoutContainer = styled.div`
  margin-right: 22px;
  font-family: 'Pretendard'; 
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  white-space:nowrap ;
  color:#797979;
`
const RemaingDayBox = styled.div`
  height: 100%;
  width: 63px;
  background-color: black;
  display: flex;

  span {
    color: var(--white);
    margin:  auto;
  }
`;
const LastestUploadDateBox = styled.div`
  height: 100%;
  margin-left: auto ;
  padding-right: 14px;

  span {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    display: flex;
    color: #797979;
    margin-top: 9px;
    margin-left: auto;
  }
`;
const MainPhotoBox = styled.div`
  width: 100%;
  /* height: 100%; */
  height: 277px;
  background-color: white;
  margin: 19px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  &.unSubs{}
`;
const PhotoContainer = styled.div`
  /* width: 370px; */
  width: 100%;
  height: 8vh;
  background-color: var(--white);
  margin: 14px auto 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: 2px;
  padding-right: 2px;
  z-index: 0;
`;
interface PhotoWrapperProps {
  isActive: boolean;
};

const PhotoWrapper = styled.div`
  width: 19%;
  height: 100%;
  position: relative;
  opacity: 0.2;
  transition: opacity 0.5s ease-in-out;

  &.active {
    background-color: white;
    box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.25);
    z-index:8;
    margin-top: -4px;
    opacity: 1;
  }
`;
const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit:cover;

  &.active {
  }
`;
const ContextContainer = styled.div`
  max-width: 337px;
  width: 100%;
  height: 173px;
  display: flex;
  flex-direction: column;
  margin: 23px auto;
`;
const Topbox = styled.div`
  max-width: 350px;
  width: 100%;
  height: 20px;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
`;
const Line = styled.div`
  width: 32%;
  height: 10px;
  border-bottom: solid 0.5px rgba(212, 212, 212, 1);
`;
const MotoFont = styled.div`
  font-family: "juana";
  margin: 0 9px 11px 9px;
  font-size: 13px;
  @media (max-width: 320px){
    font-size: 10.5px;
  }
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  letter-spacing: -0.5px;
  color: #717171;
`;
const TextBox = styled.div`
  width: 264px;
  height: 70px;
  display: flex;
  flex-direction: column;
  margin: 18px auto 0;
`;
const BoldText = styled(BigText)`
  margin: 0 auto;
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 14px;
`;
const TinyText = styled(SmallText)`
  color: #000000;
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 200;
  font-size: 13px;
  line-height: 18px;
  text-align: center;

  margin: 19px auto 0;
`;
const ButtonContainer = styled.div`
  max-width: 337px;
  width: 100%;
  height: 47px;
  margin-top: 18px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const ButtonWrapper = styled.div`
  max-width: 160px;
  width: 49%;
  height: 100%;
`;
const MainImgContainer = styled.div`
  height: 100%;
`

const MainImg = styled.img`
  width: 100%;
  height: 100%;
  /* object-fit: cover; */
`;
const NaviContainer = styled.div`
  width: 100%;
  height: 82px;
  border-top: solid 1px rgba(221, 221, 221, 1) ;
  display: flex;
  flex-direction: row;
`;
interface ImageContainerProps {
  isActive?: boolean;
};
const ImageContainer = styled.div<ImageContainerProps>`
  display: flex;
  /* width: ${props => props.isActive ? '67px' : '75px'}; */
  width: ${props => props.isActive ? '90%' : '100%'};
  /* height: ${props => props.isActive ? '63px' : '56px'}; */
  height: ${props => props.isActive ? '70%' : '90%'};
  background-color: var(--light-grey);
  margin: 2px auto 0;

  &.active{
  }
`;
const UnSubsTextContainer = styled.div`
  width: 269px;
  height: 62px;
  position: absolute;
  transform: translate(-17%, 140%);
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 24.2269px;
  line-height: 31px;
  text-shadow: 2px 2px 4px rgba(37, 37, 37, 0.1);
  color: #FFFFFF;
`;
const NavButtonWrapper = styled.div`
  width: 32px;
  height: 44px;
  display: flex;
  flex-direction: column;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 100%;
  text-align: center;
  color: rgba(115, 115, 115, 1);

  &.first{
    margin: 15px auto;
  }

  &.second {
    margin: 15px auto ;
  }
`
const ImageWrpper = styled.img`
  width: 100%;
  height: 100%;
  margin-bottom: 6px;
`
const SubHeader = styled.div`
  width: 100%;
  height: 34px;
  display: flex;
  flex-direction: row;
  background-color: rgba(217, 217, 217, 0.12);
  border-top: 0.5px solid #D5D5D5;
  border-bottom: 1px solid #D5D5D5;
`;
